import PropTypes from "prop-types";
// import React from 'react';
import { useSelector } from "react-redux";
import { Navigate, useLocation, useParams } from "react-router-dom";

// project imports
import config from "../../config";

//-----------------------|| GUEST GUARD ||-----------------------//

/**
 * Guest guard for routes having no auth required
 * @param {PropTypes.node} children children element/node
 */
const GuestGuard = ({ children }) => {
  const location = useLocation();
  const account = useSelector((state) => state.auth);
  const { token } = useParams();
  const { isLoggedIn } = account;
  if ((!token || token === undefined) && isLoggedIn) {
    const from = location.state?.from;
    const safeReturn = typeof from === "string"
      && from.startsWith("/") && !from.startsWith("//")
      && !/[\\\x00-\x1f]/.test(from)
      && from.split(/[?#]/)[0].replace(/\/+$/, "") !== config.basename;
    return <Navigate to={safeReturn ? from : config.defaultPath} replace />;
  }
  return children;
};

GuestGuard.propTypes = {
  children: PropTypes.node,
};

export default GuestGuard;
